import BaseListPresenter from "../../../../base/BaseListPresenter";

class ManageClientListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  async onClickDeleteItem(index) {
    const collection = this.view.getCollectionName();
    const obj = this.objects[index];
    try {
      await this.view.showDialog({
        title: "Delete Data?",
        message: "Are you sure you want to delete?",
      });

      await this.deleteObjectUseCase.execute(collection, obj.id);
      const index = this.objects.indexOf(obj);
      this.objects.splice(index, 1);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default ManageClientListPresenter;
